﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import DIWViewport from '@/basics/diw.viewport';
import TKBasketButton from '@tk/components/tk.basket.button';
import DIWCarousel from '@/components/diw.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import DIWDialog from '@/components/diw.dialog';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@/controls/diw.form.validator';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKSelection from '@tk/controls/tk.selection';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import DIWButtonDropdown from '@/controls/diw.button.dropdown';
import { configureStore } from '@tk/utilities/tk.use.store';
import DIWSearch from '@/controls/diw.search';
import DIWMinibasket from '@/components/diw.minibasket';
import DIWStock from '@/components/diw.stock';
import DIWPriceControl from '@/components/diw.price.control';
import DIWPrice from '@/components/diw.price';
import DIWLinks from '@/components/diw.links';
import TKTable from '@tk/components/tk.table';
import CMSVideoEmbed from '@cms/ts/components/cms.video.embed';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/general.scss';
import '@scss/modules/staticcontent.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class General extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: DIWCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
            { name: 'tk-compare-info', constructor: TKCompareInfo },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-button-dropdown', constructor: DIWButtonDropdown },
            { name: 'diw-minibasket', constructor: DIWMinibasket },
            { name: 'diw-stock', constructor: DIWStock },
            { name: 'diw-price-control', constructor: DIWPriceControl },
            { name: 'diw-price', constructor: DIWPrice },
            { name: 'diw-search', constructor: DIWSearch },
            { name: 'diw-links', constructor: DIWLinks },
            { name: 'tk-table', constructor: TKTable },
            { name: 'cms-video-embed', constructor: CMSVideoEmbed },
        ]);
    }
}

new General();
